import TimezoneSelect, { allTimezones } from "react-timezone-select";

const TimezoneSelector = ({ setPayload }: { setPayload: any }) => {
  const usTimezones = Object.fromEntries(
    Object.entries(allTimezones).filter(
      ([key]) => key.startsWith("US/") || key.includes("America/")
    )
  );

  return (
    <div>
      <label htmlFor="timezone" className="block mt-4 text-gray700 W2STMedium">
        Select your timezone
      </label>
      <div className="select-wrapper mt-3">
        <TimezoneSelect
          value={setPayload?.timezone}
          onChange={(timezone: any) => {
            setPayload((prev: any) => ({ ...prev, timezone: timezone?.value }));
          }}
          timezones={usTimezones}
          placeholder="Select Option"
        />
      </div>
    </div>
  );
};

export default TimezoneSelector;
